<template>
  <div class="text-xs-center">
    <v-bottom-sheet v-model="sheet">
      <v-list dense>
        <v-list-tile
          v-for="item in eventlog"
          :key="item"
        >
          <v-list-tile-content>
            <v-list-tile-title v-text="item"></v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>
      </v-list>
    </v-bottom-sheet>
  </div>
</template>
<script>
  export default {
    data: () => ({
      sheet: false,
      eventlog:[]
    }),
    mounted: function(){
      var self = this;
      this.$bus.$on('newentry', (entry)=>{self.eventlog.push(entry)});
      this.$bus.$on('togglelog',(bool)=>{self.sheet=bool})
    },
    watch:{
      sheet:function(){
        if(!this.sheet){
          this.$emit('hidelog')
        }
      }
    },
    computed: {
      currentstatus:function(){
        var count = this.eventlog.length-1
        return this.eventlog[count]
      }

    },
    methods: {
      appendLog: function (entry) {
        console.log(entry)
        this.eventlog.push(entry)
        this.currentstatus = entry
      }
    }
  }
</script>
<style scoped>
.v-list--dense {
    padding-top: 2px;
    padding-bottom: 2px;
    max-height: 460px;
    overflow-y: scroll;
}
.v-list__tile:not(.v-list__tile--avatar) {
    height: 16px;
}
.v-list__tile__title {
    height: 16px;
    line-height: 16px;
    position: relative;
    text-align: left;
}
</style>
